module.exports = __webpack_public_path__ + "assets/img/kv-b5fa2e8b.jpg";